import ContentDefault from 'components/Shared/ContentDefault';
import { memo, useState, useEffect } from 'react';
import * as React from 'react';

import ListOrderBump from './OrderBumpDashboard/ListOrderBump';
import RegisterOrderBump from './Register';
import { ADMIN_URL_NEW } from 'settings';

const OrderBump = memo(() => {
  useEffect(() => {
    window.location.href = `${ADMIN_URL_NEW}/orderbump`;
  }, []);

  const handleRegister = (orderBump?: any) => {
    if (!orderBump) {
      setComponent(<RegisterOrderBump renderDash={renderInitialComponent} />);
    } else {
      setComponent(<RegisterOrderBump renderDash={renderInitialComponent} orderBump={orderBump} />);
    }
  };

  const renderInitialComponent = () => {
    setComponent(initialComponent);
  };

  const initialComponent = (
    <ContentDefault
      information={'Aumente as vendas adicionando produtos complementares no checkout.'}
      title="Order Bump"
      textButton="Criar Novo"
      onClickButton={handleRegister}
      componentRender={<ListOrderBump renderDash={renderInitialComponent} handleRegister={handleRegister} />}
    />
  );

  const [component, setComponent] = useState(initialComponent);

  return component;
});

export default OrderBump;
